module.exports = __webpack_public_path__ + "static/media/polygon.5208e892.png";